import { apiRequest } from "util/services";

export const NOTICE_NOTIFICATION_ALL_PATH = "notice/notification/all";

/** Query key root; prefix-invalidation refreshes every badge + list variant for a user. */
export const noticeNotificationQueryKey = (userId, filterUnread) => [
  "notice",
  "notification",
  "all",
  userId,
  filterUnread,
];

/** Badge count in header: fetch once per session; no background polling. */
export const noticeBadgeQueryOptions = {
  staleTime: Infinity,
  refetchOnWindowFocus: false,
  refetchOnMount: false,
  refetchOnReconnect: false,
};

export async function fetchNoticeNotificationAll(userId, filterUnread) {
  const res = await apiRequest(
    NOTICE_NOTIFICATION_ALL_PATH,
    "POST",
    { user_id: userId, filter_unread: filterUnread },
    true,
  );
  if (res === false || res?.cancel) {
    throw new Error("NOTIFICATION_REQUEST_FAILED");
  }
  return res;
}

/**
 * Map API envelope to panel list state (matches legacy TopMenu handling).
 */
export function derivePanelStateFromNoticeResponse(response, showLast30Days) {
  if (response == null) {
    return null;
  }
  if (response?.notifications || response?.success) {
    if (response?.success) {
      return {
        showNoUnreadAvailable: true,
        tempList: [],
        notificationList: [],
        showEmptyState: false,
      };
    }
    if (response?.notifications?.length === 0) {
      return {
        showNoUnreadAvailable: false,
        showEmptyState: true,
        tempList: [],
        notificationList: [],
      };
    }
    const list = response.notifications;
    const tempList =
      list.length > 5 && !showLast30Days ? list.slice(0, 5) : list;
    return {
      showNoUnreadAvailable: false,
      showEmptyState: false,
      notificationList: list,
      tempList,
    };
  }
  return null;
}

export function deriveUnreadBadgeCount(response) {
  if (response?.success) {
    return 0;
  }
  if (!response?.notifications) {
    return 0;
  }
  return response.notifications.filter((item) => item.status === 0)?.length ?? 0;
}

/**
 * Full /console/notifications page: full list, no truncation (unlike TopMenu panel).
 */
export function deriveFullPageNoticeState(response) {
  if (response == null) {
    return { list: [], noUnread: false, empty: false };
  }
  if (response?.success) {
    return { list: [], noUnread: true, empty: false };
  }
  if (response?.notifications) {
    const notifs = response.notifications;
    return {
      list: notifs,
      noUnread: false,
      empty: notifs.length === 0,
    };
  }
  return { list: [], noUnread: false, empty: false };
}
